jQuery(document).ready(function($) {
    if ($('section.club-of-the-future').length > 0) {
        if ($('section.club-of-the-future.club-os').length > 0) {
            sessionStorage.removeItem('dateSelect');
            sessionStorage.removeItem('timeSelect');
            let timeoutId = 0, attempts = 0, fPlusTour = false;
            if ($('#formFitnessPlusTour').length > 0) {fPlusTour = true;}
            (function availabilities() {
                let visibility = 1;
                jQuery('body').append('<div class="ekko-lightbox modal"><div class="loader custom"><div class="runner"></div></div></div><div class="modal-backdrop show"></div>');
                $.ajax( {
                    url: "/wp-json/anytime/v1/bat-availability/",
                    type: 'POST',
                    dataType : 'json',
                    data: {
                        afnumber: formData.form_obj.find('input[name="ClubId"]').val(),
                        duration: bookATourVars.apptIntervals,
                        buffer: bookATourVars.bufferTime
                    },
                }).done(function (data) {
                    attempts = 0;
                    let availabilitiesArray = [], dateSelect, timeSelect;
                    jQuery('#date-tabs, #time-tabs').empty();
                    if (data.length > 0) {
                        for (let i = 0; i < data[0].availabilities.length; i++) {
                            let slotDateTime = new Date((typeof data[0].availabilities[i].startDate === "string" ? new Date(data[0].availabilities[i].startDate) : data[0].availabilities[i].startDate).toLocaleString("en-US", {timeZone: bookATourVars.timezone})),
                                monthAdjusted = (slotDateTime.getMonth() + 1),
                                amOrPm = (slotDateTime.getHours() > 11 ? 'pm' : "am"),
                                displayTime = (slotDateTime.getHours() % 12 || 12) + ":" + (slotDateTime.getMinutes() > 0 ? slotDateTime.getMinutes() : "00") + " " + amOrPm,
                                timeKey = slotDateTime.getHours() + '' + (slotDateTime.getMinutes() > 0 ? slotDateTime.getMinutes() : "00"), // concat to make it a string rather than a sum
                                dateKey = slotDateTime.getFullYear() + '' + (monthAdjusted < 10 ? "0" + monthAdjusted : monthAdjusted) + (slotDateTime.getDate() < 10 ? "0" + slotDateTime.getDate() : slotDateTime.getDate()); // concat to make it a string rather than a sum

                            if (typeof availabilitiesArray[dateKey] == "undefined") {
                                availabilitiesArray[dateKey] = [];
                                availabilitiesArray[dateKey]['slots'] = [];
                                availabilitiesArray[dateKey]['monthDisplay'] = monthsArray[slotDateTime.getMonth()];
                                availabilitiesArray[dateKey]['yearDisplay'] = slotDateTime.getFullYear();
                                availabilitiesArray[dateKey]['dayOfWeekDisplay'] = daysArray[slotDateTime.getDay()];
                                availabilitiesArray[dateKey]['dayOfMonthDisplay'] = slotDateTime.getDate();
                            }
                            if (typeof availabilitiesArray[dateKey]['slots'][timeKey] == "undefined" && timeKey.toString().indexOf('15', 1) === -1 && timeKey.toString().indexOf('45', 1) === -1) {
                                availabilitiesArray[dateKey]['slots'][timeKey] = [displayTime, data[0].availabilities[i].startDate];
                            }
                        }
                    }
                    if (Object.keys(availabilitiesArray).length == 0) {
                        jQuery('#formClubOfTheFuture, .form-header small, #formFitnessPlusTour').hide();
                        jQuery('.form-body').append('<h5>'+bookATourVars.noAvailTimesMessage+'</h5>');
                    } else {
                        availabilitiesArray.forEach(function (dayItem, index) {
                            jQuery('#date-tabs').append(
                                '<input class="sr-only date-select today" name="appt_date" value="' + dayItem['monthDisplay'] + ' ' + dayItem['dayOfMonthDisplay'] + ', ' + dayItem['yearDisplay'] + '" type="radio" id="day' + index + '" required="" data-parsley-multiple="appt_date">' +
                                '<label for="day' + index + '" class="d-flex flex-column flex-fill text-center border rounded ' + (fPlusTour ? 'mr-2' : 'm-1') + ' no-asterisk">' +
                                (fPlusTour ? '<span class="p-2 bg-gray-light text-heading">' : '<small class="mb-2 p-1 bg-gray"><strong>') + '' + dayItem['dayOfWeekDisplay'] + (fPlusTour ? '</span>' : '</strong></small>') +
                                '<div class="px-1' + (fPlusTour ? ' py-3' : '') + '">' + (fPlusTour ? '<span class="text-disclaimer">' : '<small>') + dayItem['monthDisplay'] + (fPlusTour ? '</span>' : '</small>') + '<div class="h3 ' + (fPlusTour ? 'mt-1 mb-0' : 'm-0') + '">' + dayItem['dayOfMonthDisplay'] + '</div></div></label>');
                        });
                        jQuery("#time-prompt").show();
                        jQuery('#date-tabs .date-select').on('change', function () {
                            let dateTab = jQuery(this).attr('id').replace(/day/g, '');
                            sessionStorage.setItem('dateSelect', dateTab);
                            jQuery("#time-tabs").empty().removeAttr("style");
                            jQuery("#time-prompt").hide();
                            availabilitiesArray[dateTab]['slots'].forEach(function (timeSlot, tsindex) {
                                jQuery('#time-tabs').append(
                                    '<input data-time-slot="' + timeSlot[1] + '" class="sr-only time-select" name="appt_time" value="' + timeSlot[0] + '" type="radio" id="time' + tsindex + '" required="" data-parsley-multiple="appt_time">' +
                                    '<label for="time' + tsindex + '" class="day' + dateTab + ' d-flex flex-column flex-fill ' + (fPlusTour ? 'justify-content-center text-disclaimer' : 'm-1 border') + ' text-center rounded no-asterisk">' + (fPlusTour ? '' : '<small class="p-1">') + '<strong>' + timeSlot[0] + '</strong>' + (fPlusTour ? '' : '</small>') + '</label>');
                            });
                            jQuery('#time-tabs .time-select').on('change', function () {
                                let timeTab = jQuery(this).attr('id').replace(/time/g, '');
                                sessionStorage.setItem('timeSelect', timeTab);
                            });
                        });
                        dateSelect = sessionStorage.getItem('dateSelect'), timeSelect = sessionStorage.getItem('timeSelect');
                        if (dateSelect) {
                            document.getElementById('day' + dateSelect).checked = true;
                            jQuery('#day' + dateSelect).trigger("change");
                        }
                        if (timeSelect) {
                            document.getElementById('time' + timeSelect).checked = true;
                        }
                        timeoutId = setTimeout(availabilities, 120000); // 2 minutes
                        function handleTabSwitching() {
                            visibility = 0;
                            clearTimeout(timeoutId);
                            if (document.visibilityState === 'visible' && visibility == 0 && (typeof timeoutId === 'undefined' || timeoutId == 0)) {
                                visibility = 1;
                                document.removeEventListener('visibilitychange', handleTabSwitching);
                                timeoutId = setTimeout(availabilities, 5000); // 5 seconds
                            } else {
                                timeoutId = 0;
                            }
                        }
                        document.addEventListener('visibilitychange', handleTabSwitching);
                    }
                }).fail(function (jqXHR) {
                    if (typeof jqXHR.responseJSON !== 'undefined') {
                        console.log(jqXHR.responseJSON.message);
                    }
                    attempts++;
                    clearTimeout(timeoutId);
                    if (attempts > 1) {
                        jQuery('#formClubOfTheFuture, .form-header small, #formFitnessPlusTour').hide();
                        jQuery('.form-body').append('<h5>'+bookATourVars.somethingWentWrongMessage+'</h5>');
                    } else {
                        timeoutId = setTimeout(availabilities, 5000); // 5 seconds
                    }
                }).always(function () {
                    jQuery('.ekko-lightbox.modal, .modal-backdrop.show').remove();
                });
            })();
        } else {
            let datum = new Date().toLocaleString("en-US", {timeZone: bookATourVars.timezone, formatMatcher: "basic", hour12: false }),
                js_current_time_for_time_zone = new Date(datum),
                now = new Date(Date.UTC(js_current_time_for_time_zone.getFullYear(), js_current_time_for_time_zone.getMonth(), js_current_time_for_time_zone.getDate(), js_current_time_for_time_zone.getHours(), js_current_time_for_time_zone.getMinutes(), js_current_time_for_time_zone.getSeconds(), 0)),
                currentTime = now.getTime()/1000;

            jQuery('#date-tabs .date-select').on('change',function() {
                let openTime = jQuery(this).data('openTime'),
                    stopTime = jQuery(this).data('stopTime'),
                    openTime2 = jQuery(this).data('openTime2'),
                    stopTime2 = jQuery(this).data('stopTime2'),
                    today = jQuery(this).hasClass('today'),
                    tomorrow = jQuery(this).hasClass('tomorrow');
                jQuery("#time-tabs").removeAttr("style");
                jQuery("#time-prompt").hide();
                jQuery('#time-tabs .time-select').each(function(){
                    let timeSlot = jQuery(this).data('timeSlot');
                    if ((today && (currentTime+bookATourVars.bufferTime) > timeSlot) || (tomorrow && (currentTime+bookATourVars.bufferTime) > (timeSlot+86400))) {
                        jQuery(this).prop('disabled',true).prop('checked',false);
                    } else if (openTime2 != undefined && timeSlot > stopTime && (timeSlot < openTime2 || timeSlot > stopTime2)) {
                        jQuery(this).prop('disabled',true).prop('checked',false);
                    } else if (timeSlot < openTime || (stopTime2 == undefined && timeSlot > stopTime)) {
                        jQuery(this).prop('disabled',true).prop('checked',false);
                    } else {
                        jQuery(this).prop('disabled',false);
                    }
                });
            });
        }

        function handleDateTimeRadioButtons() {
            if (typeof jQuery('#date-tabs .date-select:checked').val() !== 'undefined') {
                let dateTimeRadioButtons = jQuery("#date-tabs .date-select"),
                    selectedIndex = dateTimeRadioButtons.index(dateTimeRadioButtons.filter(':checked'));
                if (selectedIndex < 6) {
                    jQuery('#date-tabs .date-select').eq(selectedIndex+1).click();
                } else {
                    jQuery('#date-tabs .date-select').eq(selectedIndex-1).click();
                }
                jQuery('#date-tabs .date-select').eq(selectedIndex).click();
            }
        }
        // handle back browser button
        handleDateTimeRadioButtons();
        // handle frozen user every 30 minutes
        setInterval(handleDateTimeRadioButtons, 1000 * 60 * 30);
    }
});